import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MessageService } from 'primeng/api';
import { Producto } from '@p-parametria/mantenimiento/abc-empresas/interfaces/producto';
import { TiposCredito } from './interfaces/tipos-credito';
import { ExporterService } from '@shared/services/exporter/exporter.service';
import { ProductosService } from './services/productos.service';

import Swal from 'sweetalert2';
import { TiposCreditoFormComponent } from './tipos-credito-form/tipos-credito-form.component';
import { LoadingComponent } from '@app/theme/loading/loading.component';
import { CopiarTiposCreditoDialogComponent } from './copiar-tipos-credito-dialog/copiar-tipos-credito-dialog.component';

@Component({
  selector: 'app-tipos-credito',
  templateUrl: './tipos-credito.component.html',
  providers: [MessageService]
})
export class TiposCreditoComponent implements OnInit {
  public columns = [
    { field: 'producto', header: 'Tipo de Producto' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'tipoCredito', header: 'Tipo de Ahorro' },
    { field: 'moneda', header: 'Moneda' },
    { field: 'actions', header: '' },
  ];

  dataSource = {
    data: []
  };

  public loading: boolean = false;
  public allData: number = 0;
  public displayCopiarDialog: boolean = false;
  private readonly _width: string = '900px';

  constructor(
    private _exportService: ExporterService,
    private _perfilService: ProductosService,
    public _dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public loadingComp: LoadingComponent,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  applyFilter(filterValue: string) {
    // La funcionalidad de filtro ahora la maneja PrimeNG automáticamente
  }

  loadData() {
    this.loading = true;
    this._perfilService.read().subscribe((res) => {
      this.dataSource.data = res.data;
      if (res.data) this.allData = res.data.length;
      this.loading = false;
    });
  }

  exportAsXLSX(): void {
    this._exportService.exportToExcel(
      this.dataSource.data,
      'my_export'
    );
  }

  openForm(model?: Producto) {
    const dialogRef = this._dialog.open(TiposCreditoFormComponent, {
      width: this._width,
      data: model,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.loadData();
      }
    });
    dialogRef.componentInstance.onSave.subscribe(() => {
      this.loadData();
    });
  }

  delete(model: Producto) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Desea eliminar el tipo de crédito ${model.producto}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this._perfilService.delete(model).subscribe({
          next: (res) => {
            if (res.exito === 1) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Tipo de crédito eliminado correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo eliminar el tipo de crédito'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el tipo de crédito'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, 'Cerrar', {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom'
    });
  }

  openCopiarDialog(): void {
    this.displayCopiarDialog = true;
  }

  onCopiarDialogClosed(event?: any): void {
    this.displayCopiarDialog = false;
    if (event) {
      if (event.success) {
        this.messageService.add({
          severity: 'success',
          summary: 'Éxito',
          detail: event.message
        });
        this.loadData();
      } else if (event.error) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: event.error
        });
      }
    }
  }
}
